import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { LecturerPaymentRateListItem } from '../../../../../api/types/lecturers/price-rate/lecturer-payment-rate-list-item';
import { RatesReportFilterType } from '../rates-report-filter.type';

export const getRatesReportListOperation = async (
  filters: RatesReportFilterType,
  offset: number,
  limit: number,
  setData: (data: LecturerPaymentRateListItem[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const rateRange =
      filters.rateMin != null || filters.rateMax != null
        ? {
            ...(filters.rateMin != null ? { min: filters.rateMin } : {}),
            ...(filters.rateMax != null ? { max: filters.rateMax } : {}),
          }
        : undefined;

    const travelPriceRange =
      filters.travelRateMin != null || filters.travelRateMax != null
        ? {
            ...(filters.travelRateMin != null
              ? { min: filters.travelRateMin }
              : {}),
            ...(filters.travelRateMax != null
              ? { max: filters.travelRateMax }
              : {}),
          }
        : undefined;

    const travelRate =
      travelPriceRange != null || filters.includeNoTravelRate
        ? {
            ...(travelPriceRange != null
              ? { priceRange: travelPriceRange }
              : {}),
            ...(filters.includeNoTravelRate
              ? { includeNoTravelRate: true }
              : {}),
          }
        : undefined;

    const validityRange =
      filters.validityStart != null || filters.validityEnd != null
        ? {
            ...(filters.validityStart != null
              ? { validityStart: filters.validityStart }
              : {}),
            ...(filters.validityEnd != null
              ? { validityEnd: filters.validityEnd }
              : {}),
          }
        : undefined;

    const res = await appApi.listLecturerPaymentRates({
      branchIds: filters.branchIds ?? [],
      professorIds: (filters.professors ?? []).map((p) => p.id),
      rateRange,
      travelRate,
      displayTypes: filters.displayTypes ?? [],
      validityRange,
      requestStatuses: filters.requestStatuses ?? [],
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
